import styled from 'styled-components';

export const DetailCardInnerSection = styled.section(
  props => `
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: ${props.theme.colors.goBrandBlue.light};
`,
);

export const WrapperSection = styled.section(
  props => `
  background-color: ${props.theme.colors.goBrandBlue.light};
  width: 100%;
  flex-direction: column;
  margin: 0 0 ${props.theme.spacing.xxlarge} 0

`,
);

export const WrapperDiv = styled.div(
  props => `
  max-width: 120rem;
  width: 100%;
  padding-top: ${props.theme.spacing.large};
  margin: 0 auto;
`,
);

export const GoSafeCardBlockWrapper = styled.div(
  props => `
   margin: ${props.theme.spacing.large} auto 0;
   background-color: ${props.theme.colors.goBrandBlue.light};
   border: .1rem solid ${props.theme.colors.ash.medium};
   max-width: 120rem;
   width:100%;
  `,
);

// export const DetailsLayoutContainer: React.FC<DetailsLayoutContainerProps> = ({children}) => (
//   <DetailCardInnerSection>{children}</DetailCardInnerSection>
// );
